module.exports = __webpack_public_path__ + "static/media/external-link-icon.ca7cb840.svg";